import {
  Box,
  Divider,
  Text
} from "@chakra-ui/react";
import { Fragment } from "react";
import * as React from "react";
import { useTranslation } from "react-i18next";

function CSRDReportAnswers({ questionObj, questionIndex }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "csrd.form"
  });

  return (
    <Box
      key={questionObj.question + questionIndex}
      marginBlock={2}
      backgroundColor={questionIndex % 2 === 0 ? "esg_gray.500" : "white"}
      padding={2}
    >
      <Text><b>{t("question")}: </b>{questionObj.question}</Text>
      <Text><b>{t("answers")}: </b></Text>
      {questionObj.answers.map((answerObj, index) => {
        return <Fragment key={`${index}-${answerObj.userName}-${questionObj.question}`}>
          <Box>
            <Text size="md" color={"esg_gray.400"} as="span">
              {t("user")}
            </Text>:
            <Text size="md" marginInlineStart={1} as="span">
              {answerObj.userName}
            </Text>
          </Box>
          <Box>
            <Text size="md" color={"esg_gray.400"} as="span">
              {t("answer")}
            </Text>:
            <Text size="md" marginInlineStart={1} as="span">
              {answerObj.answer}
            </Text>
          </Box>
          <Box>
            <Text size="md" color={"esg_gray.400"} as="span">
              {t("dataSource")}
            </Text>:
            <Text size="md" marginInlineStart={1} as="span">
              {answerObj.dataSource}
            </Text>
          </Box>
          <Box>
            <Text size="md" color={"esg_gray.400"} as="span">
              {t("comment")}
            </Text>:
            <Text size="md" marginInlineStart={1} as="span">
              {answerObj.comment}
            </Text>
          </Box>
          {index < questionObj.answers.length - 1 ? <Divider marginBlock={2} /> : null}
        </Fragment>;
      })}
    </Box>
  );
}

export default CSRDReportAnswers;